import { html } from '../../utils/lit/html.js';
import { CSS_PARTS } from '../css-parts.js';

import amms from '../assets/icons/aams-icon-svg';
import over18 from '../assets/icons/over-18-icon-svg';
import amd from '../assets/icons/amd-icon-svg';
import gioco from '../assets/icons/gioco-responsabile-icon-svg';
import beGambleAwareIcon from '../assets/icons/be-gamble-aware-icon-svg.js';

import oddscheckerIconUS from '../assets/icons/oddschecker-logo-us-dark.png';
import oddscheckerIconUSLight from '../assets/icons/oddschecker-logo-us-light.png';

export const disclaimerText: string = `
    Il gioco può causare dipendenza patologica ed è vietato ai minori.
    Percentuali di vincita su ADM e sui siti degli operatori. Cliccando su una
    quota si è diretti su oddschecker, da cui è possibile accedere al sito
    dell'operatore per verificarne i principi di cui all'art. 5.6 delle linee
    guida della Legge 9 agosto 2018, n.96
  `;

function getFooterNotice(theme: string): string {
  if (theme === 'reach' || theme === 'oddschecker') {
    return '';
  } else if (theme === 'golf-monthly') {
    return `21+ Gambling problem? Call 1-800-GAMBLER`;
  }

  return disclaimerText;
}

function getFooterLegalIcons(theme: string): string {
  switch (theme) {
    case 'reach':
      return beGambleAwareIcon;
    case 'golf-monthly':
    case 'oddschecker':
      return '';
    default:
      return `
      ${amms}
      ${over18}
      ${amd}
      ${gioco}
    `;
  }
}

function getFooterPoweredBy(theme: string): string {
  if (theme === 'oddschecker') {
    return html``;
  }

  if (theme === 'chiamarsi-bomber') {
    return html`Powered by
      <img src="${oddscheckerIconUSLight}" alt="Oddschecker Logo" />`;
  }

  return html`Powered by
    <img src="${oddscheckerIconUS}" alt="Oddschecker Logo" />`;
}

export const getFooter = (theme: string): string => {
  const footerNotice = getFooterNotice(theme);
  const footerLegalIcons = getFooterLegalIcons(theme);
  const footerPoweredBy = getFooterPoweredBy(theme);

  return html`
    <footer part="${CSS_PARTS['footer']}" class="footer">
      <div part="${CSS_PARTS['footer__notice']}" class="footer__notice">
        <slot name="footer-notice"> ${footerNotice} </slot>
      </div>

      <div part="${CSS_PARTS['footer__icons']}" class="footer__icons">
        <div>
          <slot name="footer-legal-icons"> ${footerLegalIcons} </slot>
        </div>

        <div>${footerPoweredBy}</div>
      </div>
    </footer>
  `;
};
